// extracted by mini-css-extract-plugin
export var attachButton = "_kn-8";
export var sendButton = "_kn-2";
export var sendDisabled = "_kn-4";
export var sendEnabled = "_kn-3";
export var sendIcon = "_kn-6";
export var sendIconDisabled = "_kn-7";
export var sendStreaming = "_kn-5";
export var textarea = "_kn-1";
export var wrapper = "_kn-0";